<template lang="pug">
  //- vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" @vm-action="deleteClientConfirm(newRecord)" :vm-action="true" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="true" :vm-is-valid="!$v.newRecord.$invalid" :vm-active="isModalVisible" :vm-title='getTitle')
  //-   vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts=\[{ shortcut: [ 'enter', ], callback: saveRecord, push: true, focus: true, disabled: $v.newRecord.$invalid },]")
      //- vm-col(vm-justify="center", vm-align="center", vm-w=12)
      //-   b-form-group
          //- vm-input(:placeholder='$t("clients.contact_placeholder")' :danger="!$v.newRecord.contact.minLength" :danger-text="'Name must have at least 4 ' + $v.newRecord.contact.$params.minLength + ' letters.'" v-model="newRecord.contact" :label='$t("clients.contact")')
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Clients')

export default {
  name: 'ModalClients',
  props: {
    newRecord: {
      type: Object
    },
    isAdd: {
      default: true,
      type: Boolean
    }
  },
  validations: {
    newRecord: {
      // contact: {
      //   required,
      //   minLength: minLength(5)
      // },
      // email: {
      //   required,
      //   email
      // }
    }
  },
  computed: {
    ...mapGetters([
      'isModalVisible',
      'clientsCatalog'
    ]),
    getTitle () {
      return this.isAdd ? this.$t('client.add') : this.$t('client.edit')
    }
  },
  methods: {
    ...mapActions([
      'addClient',
      'editClient',
      'deleteClient',
      'setModalVisible',
      'loadCatalog'
    ]),
    saveRecord () {
      this.isAdd ? this.addClient(this.newRecord) : this.editClient(this.newRecord)
    },
    async deleteClientConfirm (LClient) {
      let t = this
      this.auxDeleteClient = () => {
        t.deleteClient(LClient)
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { attribute: this.$t(LClient.id/* columna */) }),
        accept: this.auxDeleteClient
      })
    },
    autoCompleteFunc (value, url) {
      this.loadCatalog({ filter: value, url: url })
    },
    close () {
      this.setModalVisible(false)
    }
  }
}
</script>
